import constate from 'constate';
import React from 'react';
import { GetSeriesById } from '@/core';

export type SeriesActionContext = { isTooltipPinned?: boolean };

export type RenderSeriesActionFn = (id: string, ctx: SeriesActionContext) => React.ReactNode;

export type SeriesActionProviderProps = {
  getSeriesById: GetSeriesById;
  renderSeriesAction?: RenderSeriesActionFn;
};

const [SeriesActionProvider, useSeriesActionContextStrict] = constate((args: SeriesActionProviderProps) => {
  return args;
});

export function useSeriesActionContext() {
  try {
    return useSeriesActionContextStrict();
  } catch (_e) {
    // noop
  }
}

export { SeriesActionProvider };
